import styled from "@emotion/styled";
import { Icon, Theme, Typography, useTheme } from "@yuno/design-system-web";
import { useContext } from "react";
import { ThemeContext } from "../../../../context/theme-context";
import { CustomTheme } from "../../../../types/custom-theme";
import { getStyle } from "../../common/tools/selectors/utils";
import { useTranslation } from 'react-i18next'

const Container = styled.div<{ theme?: Theme }>`
  margin-top: 16px;

  .locked-text {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    text-align: center;
    margin-top: 16px;
    color: ${({ theme }) => theme.palette.grey[3]};

    span {
      margin-left: 10px;
    }
  }
`;

const FakeButton = styled.div<{ theme?: Theme; customTheme: CustomTheme }>`
  transition: border-radius 0.4s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 54px;
  left: 864px;
  background: ${({ customTheme }) =>
    customTheme.payment_form.button.background_color};
  ${({ customTheme }) => getStyle(customTheme.payment_form.button.style)};

  font-size: 16px;

  p {
    color: ${({ customTheme }) =>
      customTheme.payment_form.button.font_color}!important;
    font-size: ${({ customTheme }) =>
      customTheme.payment_form.button.font_size}px !important;
    font-weight: ${({ customTheme }) =>
      customTheme.payment_form.button.font_weight};
  }
`;

export const Button = () => {
  const theme: Theme = useTheme();
  const { customTheme } = useContext(ThemeContext);
  const { t } = useTranslation()

  return (
    <Container>
      <FakeButton customTheme={customTheme}>
        <Typography>{t('pay')}</Typography>
      </FakeButton>
      <Typography className="locked-text">
        <Icon
          size="20px"
          name="Lock"
          color={theme.palette.grey[3]}
          weight="fill"
        />
        <span>{t('encrypted')}</span>
      </Typography>
    </Container>
  );
};
